// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"3bda239b","64":"64910560","451":"fa12f5ac","647":"c4b0dc86","681":"64379bae","822":"2f821054","830":"ca520e65","894":"faac31c8"}[chunkId] + ".chunk.js";
};